import script from "./WheelOfFortunePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./WheelOfFortunePopup.vue?vue&type=script&setup=true&lang=ts"

import "./WheelOfFortunePopup.vue?vue&type=style&index=0&id=1f0432f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f0432f0"]])

export default __exports__